import React, { useEffect, useState } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import { getShiftList } from "adminApi/DutyRosterApi/ShiftApi";

const AddRosterForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    title = "Create Duty Roster",
    shiftsOptions
}) => {



    const renderField = (field) => {
        switch (field.type) {
            case "select":
                return (
                    <FormSelect
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        options={field.name === "shift_id" ? shiftsOptions : field.options || []}
                        error={errors[field.name]}
                    />
                );
            case "date":
                return (
                    <FormDatePicker
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                        dateFormat="Y-m-d"
                    />
                );
            default:
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
        }
    };

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
            {fields.map(renderField)}

            <FormSubmitButton
                label="Save"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddRosterForm;
